import React from 'react';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';
import { SVG_COMPONENTS } from '@/assets/admin';
import { RESIDENTS_MOBILE_COLORS } from '@/constants/residents/mobile/color';
import { PAYMENT_COLORS } from '@/constants/residents/mobile/paymentColors';

/**
 * Shared icon components for payment screens
 * Centralized to avoid duplication across multiple files
 */
export const PaymentIcons = {
  ChevronLeft: () => {
    const Icon = SVG_COMPONENTS.CHEVRON_LEFT as any;
    if (!Icon) return null;
    return <Icon width={24} height={24} color={RESIDENTS_MOBILE_COLORS.TEXT_PRIMARY} />;
  },

  Card: () => {
    const Icon = RESIDENTS_SVG_COMPONENTS.CREDIT_CARD as any;
    if (!Icon) return null;
    return <Icon width={24} height={24} color={RESIDENTS_MOBILE_COLORS.BUTTON_PRIMARY} />;
  },

  Bank: () => {
    const Icon = RESIDENTS_SVG_COMPONENTS.BANK as any;
    if (!Icon) return null;
    return <Icon width={24} height={24} color={RESIDENTS_MOBILE_COLORS.BUTTON_PRIMARY} />;
  },

  CardOutline: () => {
    const Icon = RESIDENTS_SVG_COMPONENTS.CREDIT_CARD as any;
    if (!Icon) return null;
    return <Icon width={64} height={64} color={RESIDENTS_MOBILE_COLORS.TEXT_TERTIARY} />;
  },

  Trash: () => {
    const Icon = SVG_COMPONENTS.TRASH as any;
    if (!Icon) return null;
    return <Icon width={16} height={16} color={PAYMENT_COLORS.ERROR_RED} />;
  },

  Check: () => {
    const Icon = RESIDENTS_SVG_COMPONENTS.CHECK as any;
    if (!Icon) return null;
    return <Icon width={20} height={20} color={RESIDENTS_MOBILE_COLORS.BUTTON_PRIMARY} />;
  },

  Calendar: () => {
    const Icon = RESIDENTS_SVG_COMPONENTS.CALENDAR as any;
    if (!Icon) return null;
    return <Icon width={64} height={64} color={RESIDENTS_MOBILE_COLORS.TEXT_TERTIARY} />;
  },
};

